<template>
  <v-card
    class="bar-header"
    :style="{
      background: setBackgoundBox(),
      borderRadius: setBorderRadiusBox(),
    }"
  >
    <v-container style="padding: 0px 15px; height: 100%">
      <v-btn
        v-if="!hide_back"
        icon
        color="white"
        @click="redirectTo"
        style="margin-top: 26px; z-index: 2"
        elevation="2"
      >
        <v-icon large>mdi-chevron-left-circle</v-icon>
      </v-btn>
      <v-card-text
        class="text-center d-flex justify-center align-center"
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      >
        <span
          class="text-h6 white--text text-center"
          style="width: 100%"
          :style="{
            color: this.customHeader.titleColor,
            'text-shadow': checkTitleShadow(),
          }"
        >
          {{ $t(editAddress) }} {{ $t(text) }}
        </span>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { adjustHslBrightness } from "@/config/general-function";
import {
  getFontColorBasedOnBg,
  getLandingPage,
} from "../config/general-function";

export default {
  props: [
    "text",
    "site",
    "color",
    "font_color",
    "editAddress",
    "image",
    "hide_back",
    "back_landing",
    "redirect_name",
    "redirect_path",
    "redirect_param",
    "redirect_query",
  ],
  data: () => ({
    customHeaderPage: "",
    customHeader: {
      isUseCustomHeader: false,
      isUseTitle: true,
      image: "",
      titleColor: "#ffffff",
    },
  }),
  methods: {
    setBackgoundBox() {
      const _color = this.color || this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.image) {
        _style = `url("${this.image}") center / cover no-repeat`;
      }
      return _style;
    },
    checkTitleShadow() {
      let shadow = "rgb(224 224 224) 2px 1px 1px";
      const color = getFontColorBasedOnBg(this.font_color || "#ffffff", "bw");
      if (color == "#000000") {
        shadow = "rgb(66, 68, 90) 2px 1px 1px";
      }
      return shadow;
    },
    setBorderRadiusBox() {
      let _style = `0px 0px 25px 25px`;
      if (this.image) {
        _style = `0px !important`;
      }
      return _style;
    },
    redirectTo() {
      const prevRoute = this.$router.previousRoute;
      // ========== ========== ========== ==========
      if (
        this.text === "friendRecommend" ||
        this.text === "friendRequest" ||
        this.text === "friendList"
      ) {
        const targetRoute = this.$router.resolve({
          name: "main",
        });
        window.location.href = targetRoute.href;
      } else if (this.redirect_name || this.redirect_param) {
        let detail = {};
        if (this.redirect_name) {
          detail = {
            name: this.redirect_name,
          };
        }
        if (this.redirect_path) {
          detail = {
            path: this.redirect_path,
          };
        }
        if (this.redirect_param) {
          detail = {
            ...detail,
            params: { ...this.redirect_param },
          };
        }
        if (this.redirect_query) {
          detail = {
            ...detail,
            query: { ...this.redirect_query },
          };
        }
        this.$router.push({ ...detail });
      } else {
        if (prevRoute && !this.back_landing) {
          this.$router.go(-1);
        } else {
          let listRouteName = [];
          if (
            Array.isArray(this.site?.bottom_nav_bar?.menu) &&
            this.site?.bottom_nav_bar?.menu?.length > 0
          ) {
            const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
              (x) => x.route_allow
            );
            for (let item of listRouteAllow) {
              listRouteName = [...listRouteName, ...item];
            }
          }
          if (listRouteName.length > 0) {
            this.$router.push({ name: listRouteName[0] });
          } else {
            const landing_page = getLandingPage();
            const targetRoute = this.$router.resolve({
              name: landing_page,
            });
            window.location.href = targetRoute.href;
          }
        }
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
.bar-header {
  height: 150px;
  border-bottom-left-radius: 25px !important;
  font-size: 14px;
  border-bottom-right-radius: 25px !important;
}
</style>
